export enum BankIdDevice {
    ThisDevice = 'this',
    ExternalDevice = 'external'
}